import React, { useState, useEffect } from "react";
import { Content, Main } from "../../../components/Layout";
import { Row, Col, Form, Table, Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../../services/api";
import IcX from "../../../components/Svg/IcX";
import IcLixo from "../../../components/Svg/IcLixo";
import tableStyle from "../../../components/Table/Table.module.css";
import buttonStyle from "../../../components/Button/Button.module.css";
import modalStyle from "../../../components/Modal/style.module.css";
import Slct from "../../../components/Slct";
import { ModalConfirm } from "../../../components/Modal";
import Loading from "../../../components/Loading";
import styles from "./style.module.css";
import useWrapper from "../../../hooks/useWrapper";
import { Currency } from "../../../components/Input";

import useFormat from "../../../hooks/utils/useFormat";

export default function TemplateBusiness() {
  const { setbreadcrumb, config } = useWrapper();
  const { formatReal } = useFormat();
  const navigate = useNavigate();
  const { templateId } = useParams();

  const [loadingPage, setLoadingPage] = useState(true);
  const [template, setTemplate] = useState({
    title: "",
    description: "",
  });
  const [supliers, setSupliers] = useState([]);
  const [resources, setResources] = useState([]);
  const [rows, setRows] = useState([]);
  const [suportRow, setSuportRow] = useState([]);
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);
  const handleRows = rows => {
    const data = rows.map(row => {
      return {
        category_id: row.category_id,
        provider_id: row.provider_id,
        resource_id: row.resource_id,
        description: row.description,
        qtd: row.qtd,
        single_value: row.single_value,
      };
    });

    return data;
  };

  const handleSubmit = event => {
    const form = event.currentTarget;
    event.preventDefault();
    let _error = [];
    document.querySelectorAll(".input-empty").forEach(e => {
      e.classList.remove("input-empty");
    });
    if (!template.title) {
      _error.push({ el: "title" });
    }
    if (!category) {
      _error.push({ el: "category", parent: true });
    }
    if (!rows.length) {
      _error.push({ el: null, customText: "É necessário adicionar recursos!" });
    }
    if (!_error.length) {
      const handledRows = handleRows(rows);
      const data = {
        title: template.title,
        description: template.description,
        resources: handledRows,
        category_id: category,
      };
      if (form.checkValidity() === false) {
        event.stopPropagation();
      } else {
        if (templateId) {
          editContent(templateId, data);
        } else {
          saveContent(data);
        }
      }
    } else {
      let _custom_text_el = _error.find(el => el.customText);
      if (_custom_text_el) {
        toast.error(_custom_text_el.customText);
      } else {
        toast.error("Preencha todos os dados obrigatórios!");
      }
      setTimeout(() => {
        _error.forEach(er => {
          if (er.parent) {
            document.querySelectorAll(`*[name="${er.el}"]`).forEach(el => {
              el.parentElement.classList.add("input-empty");
            });
          } else {
            document.querySelectorAll(`*[name="${er.el}"]`).forEach(el => {
              el.classList.add("input-empty");
            });
          }
        });
      }, 200);
    }
  };

  async function editContent(templateId, data) {
    try {
      await api.put(`template-business/${templateId}`, data, config);
      toast.success("Conteúdo salvo com sucesso!");
      navigate(`/business/templatebusiness`);
    } catch (error) {
      toast.error("Falha ao salvar os dados.");
    }
  }

  async function saveContent(data) {
    try {
      await api.post("template-business", data, config);
      toast.success("Conteúdo salvo com sucesso!");
      navigate(`/business/templatebusiness`);
    } catch (error) {
      toast.error("Falha ao salvar os dados.");
    }
  }

  function generatorProvider(dados) {
    let data = [];
    dados.forEach(item => {
      if (item.provider !== undefined && item.provider.length > 0) {
        item.provider.forEach(dt => {
          if (data[item.id] === undefined) {
            data[item.id] = [];
          }
          data[item.id].push(dt);
        });
      }
    });
    setSupliers(data);
  }

  const [category, setCategory] = useState(null);
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    api.get("categories", config).then(response => {
      setCategories(
        response.data.data
          .filter(e => e.only_attendance === 0)
          .map(e => ({
            value: e.id,
            label: e.name,
          })),
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount; `config` is a new object every WrapperProvider render and would cause repeated re-fetches
  }, []);

  useEffect(() => {
    api.get(`resources`, config).then(response => {
      setResources(
        response.data
          .filter(e => e.category.id === category)
          .map(e => ({
            value: e.id,
            label: e.name,
            category_id: e.category.id,
          })),
      );
      generatorProvider(response.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `config` is a new object every WrapperProvider render; including it would re-trigger this fetch on unrelated context updates
  }, [category]);

  function setPriceForEvent(value) {
    let money = 0;

    value !== undefined &&
      value.length > 0 &&
      value.forEach((v, key) => {
        money = money + parseFloat(value[key].total);
      });
  }

  useEffect(() => {
    if (templateId) {
      if (supliers.length > 0) {
        api
          .get(`template-business/${templateId}`, config)
          .then(response => {
            let arrayResources = [];
            if (response.data.templateBusinessResource.length > 0) {
              setCategory(response.data.templateBusinessResource[0].category_id);
            }

            response.data.templateBusinessResource.forEach(item => {
              let options = [];

              if (!!supliers[item.resource_id]) {
                supliers[item.resource_id].forEach(e => {
                  options.push({
                    label: e.name,
                    value: e.id,
                  });
                });
              }

              arrayResources.push({
                resource_name: item.resource.name,
                category_id: item.category_id,
                provider_id: item.provider_id,
                resource_id: item.resource_id,
                description: item.description,
                qtd: item.qtd,
                single_value: item.single_value,
                total: item.single_value * parseInt(item.qtd),
                providers: options,
              });
            });

            setRows(arrayResources);
            setPriceForEvent(arrayResources);
            setTemplate(response.data);
          })
          .then(() => {
            setLoadingPage(false);
          });
      }
    } else {
      setLoadingPage(false);
    }
    // console.log(supliers)
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `config` is a new object every WrapperProvider render; including it would re-trigger this fetch on unrelated context updates
  }, [supliers, templateId]);

  const handleAddRows = () => {
    const values = [...rows];
    let options = [];
    supliers[suportRow.resource_id] &&
      supliers[suportRow.resource_id].forEach(e => {
        options.push({
          label: e.name,
          value: e.id,
        });
      });

    values.push({
      resource_name: suportRow.resource_name,
      category_id: suportRow.category_id,
      provider_id: suportRow.provider_id,
      resource_id: suportRow.resource_id,
      description: "",
      qtd: 0,
      single_value: 0,
      total: 0,
      providers: options,
    });
    setRows(values);
  };

  const handleRemoveRows = index => {
    const values = [...rows];
    if (values.length >= 1) {
      values.splice(index, 1);
      setRows(values);
    }
  };

  function addResources() {
    setSuportRow({
      resource_name: null,
      category_id: null,
      provider_id: null,
      resource_id: null,
      description: null,
      qtd: null,
      single_value: null,
    });

    handleShow2();
  }

  const handleChangeDescription = (index, event) => {
    const values = [...rows];
    values[index].description = event.target.value;
    setRows(values);
  };

  const handleChangeQtd = (index, event) => {
    const values = [...rows];
    values[index].total = values[index].single_value * parseInt(event.target.value);
    values[index].qtd = parseInt(event.target.value);
    setRows(values);
  };

  const handleValueString = event => {
    setTemplate({
      ...template,
      [event.target.name]: event.target.value,
    });
  };

  const [deleteModal, setDeleteModal] = useState(false);
  const deleteModel = () => {
    api.delete(`template-business/${templateId}`, config).then(() => {
      navigate(`/business/templatebusiness`);
      toast.success("Modelo deletado com sucesso!");
    });
  };

  useEffect(() => {
    if (template) {
      setbreadcrumb([
        { label: "Comercial", url: "/business" },
        { label: "Modelos de Orçamentos", url: "/business/templatebusiness" },
        { label: template.title },
      ]);
    }
  }, [template, setbreadcrumb]);

  return (
    <Main>
      <ModalConfirm
        show={deleteModal}
        title="Apagar Modelo"
        text={`Deseja apagar o Modelo "${template.title}"?`}
        confirm={deleteModel}
        closeModal={() => {
          setDeleteModal(false);
        }}
        colorScheme="error"
      />
      <Content>
        {!loadingPage ? (
          <div>
            <Row>
              <Col>
                <h2 className="page-title">Novo Modelo de Orçamento</h2>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <Form.Group className="lince-input">
                  <span className="lince-input_label">Nome do modelo*</span>
                  <div className="lince-input__text">
                    <Form.Control
                      type="text"
                      maxlength="35"
                      placeholder="Crie um nome para o seu modelo com no máx. 35 caracteres"
                      onChange={event => handleValueString(event)}
                      value={template.title}
                      name="title"
                    />
                  </div>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="lince-input">
                  <span className="lince-input_label">Categoria</span>
                  <div className="lince-input__text">
                    <Slct
                      options={categories}
                      value={category}
                      name="category"
                      onChange={e => {
                        setCategory(e.value);
                      }}
                      className="w-100"
                      placeholder="..."
                      isDisabled={!!templateId || rows.length > 0}
                    />
                  </div>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <Form.Group className="lince-input">
                  <span className="lince-input_label">Descrição</span>
                  <div className="lince-input__text">
                    <Form.Control
                      type="text"
                      maxlength="120"
                      placeholder="Descreva o modelo com no máx. 120 caracteres"
                      onChange={event => handleValueString(event)}
                      name="description"
                      value={template.description}
                    />
                  </div>
                </Form.Group>
              </Col>
            </Row>
            <Form onSubmit={handleSubmit}>
              <Row className="mt-3">
                <Col>
                  <Table className={tableStyle.table}>
                    <thead>
                      <tr>
                        <th style={{ width: "15%" }}>Recurso</th>
                        <th style={{ width: "15%" }}>Fornecedor</th>
                        <th style={{ width: "20%" }}>Especificações</th>
                        <th style={{ width: "80px" }}>Quant</th>
                        <th>Valor Unitário</th>
                        <th>Total</th>
                        <th style={{ width: "55px" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows !== undefined &&
                        rows.length > 0 &&
                        rows.map((value, index) => (
                          <tr>
                            <td>{rows[index].resource_name}</td>
                            <td>
                              <Slct
                                options={rows[index].providers}
                                value={rows[index].provider_id || ""}
                                placeholder="..."
                                onChange={e => {
                                  let rowsVar = [...rows];
                                  rowsVar[index].provider_id = e.value;
                                  setRows(rowsVar);
                                }}
                              />
                            </td>
                            <td>
                              <div className="lince-input__text">
                                <Form.Control
                                  type="text"
                                  onChange={event => handleChangeDescription(index, event)}
                                  name="description"
                                  value={rows[index].description || ""}
                                />
                              </div>
                            </td>
                            <td>
                              <div className="lince-input__text">
                                <Form.Control
                                  type="text"
                                  min="0"
                                  onChange={event => handleChangeQtd(index, event)}
                                  name="qtd"
                                  value={rows[index].qtd || ""}
                                />
                              </div>
                            </td>
                            <td>
                              <div className="lince-input__text">
                                <Currency
                                  value={rows[index].single_value || 0}
                                  valueChange={ev => {
                                    let _rows = [...rows];
                                    _rows[index].single_value = ev;
                                    setRows(_rows);
                                  }}
                                />
                              </div>
                            </td>
                            <td>
                              <div className="lince-input__text">
                                <Currency
                                  value={rows[index].single_value * rows[index].qtd}
                                  valueChange={() => {}}
                                  disabled={true}
                                />
                              </div>
                            </td>
                            <td className="text-right">
                              <button type="button" onClick={() => handleRemoveRows(index)} className="simple-ico">
                                <IcLixo />
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                  <div className="d-flex justify-content-between">
                    <div className="print-hide">
                      <button
                        type="button"
                        className={buttonStyle.button_success_soft}
                        onClick={() => {
                          if (category) {
                            addResources();
                          } else {
                            document.querySelectorAll(".input-empty").forEach(e => {
                              e.classList.remove("input-empty");
                            });
                            setTimeout(() => {
                              document.querySelectorAll(`*[name="category"]`).forEach(el => {
                                el.parentElement.classList.add("input-empty");
                              });
                            }, 20);
                            toast.error("Selecione uma categoria");
                          }
                        }}
                      >
                        <span>Adicionar Recurso</span>
                      </button>
                    </div>
                    <div>
                      <div className={styles.total}>
                        <p>Total</p>
                        <p>
                          {formatReal(
                            rows.reduce(
                              (__acc, __resource) =>
                                (Number(__resource.qtd) || 0) * (Number(__resource.single_value) || 0) + __acc,
                              0,
                            ),
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="text-right mt-4">
                  {templateId && (
                    <button
                      type="button"
                      className={buttonStyle.button_ghost_error}
                      onClick={() => {
                        setDeleteModal(true);
                      }}
                    >
                      Apagar Modelo
                    </button>
                  )}
                  <button type="submit" className={`ml-3 ${buttonStyle.button_primary}`}>
                    {templateId ? "Salvar" : "Criar"} Modelo
                  </button>
                </Col>
              </Row>
            </Form>
          </div>
        ) : (
          <Loading />
        )}
      </Content>
      <Modal show={show2} onHide={handleClose2} aria-labelledby="example-modal-sizes-title-lg" centered>
        <Modal.Header>
          <Modal.Title>Novo Recurso</Modal.Title>
          <button className={modalStyle.closeModal} onClick={handleClose2}>
            <IcX />
          </button>
        </Modal.Header>
        <Modal.Body>
          <Row className="mt-1">
            <Col>
              <Slct
                options={resources}
                value={suportRow.resource_id || ""}
                placeholder="..."
                onChange={e => {
                  setSuportRow({
                    ...suportRow,
                    resource_id: e.value,
                    resource_name: e.label,
                    category_id: e.category_id,
                  });
                }}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col className="text-right mt-3">
              <button
                onClick={handleAddRows}
                disabled={suportRow.resource_id === "" ? true : false}
                className={buttonStyle.button_primary}
              >
                Adicionar
              </button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </Main>
  );
}
